// SPDX-License-Identifier: AGPL-3.0-or-later

import ChannelSticker from '@app/features/channel/state/ChannelSticker';
import Slowmode from '@app/features/slowmode/state/Slowmode';

function clearSendScopedSticker(channelId: string): void {
	ChannelSticker.clearPendingStickerOnMessageSend(channelId);
}

function markSlowmodeSend(channelId: string): void {
	Slowmode.recordMessageSend(channelId);
}

export function recordMessageSend(channelId: string): void {
	clearSendScopedSticker(channelId);
	markSlowmodeSend(channelId);
}

export function updateSlowmodeTimestamp(channelId: string, timestamp: number): void {
	Slowmode.updateSlowmodeTimestamp(channelId, timestamp);
}
